@if (renderMultipleLocks()) {
  @for (lock of lockBoxes; track lock) {
    <icc-select-box
      [title]="lock.title"
      [description]="lock.description"
      [imageUrl]="lock.imageUrl"
      (select)="openLocksOptions(lock)"
      [buttonText]="'INTERFACE|Zmień' | translate"
      [disabledButton1]="locks.length <= 1"
    ></icc-select-box>
  }
} @else {
  <icc-list
    [searchable]="true"
    [items]="locks"
    [itemTemplate]="'itemImgTitle'"
    itemImgHeight="medium"
    (select)="selectLock($event)"
    [selected]="selectedLock$ | async"
  ></icc-list>
}


